//libs
import { Link } from 'react-router-dom';
//styling
import './NotFound.scss';

//assets
import HomeLink from '../../components/_default/HomeLink';

function NotFound() {
  return (
    <main>
      <HomeLink />
      <section className='notFound_content'>
        <h1 className='notFound_title'>404</h1>
        <p className='notFound_subtitle'>the page you are looking for was not found!</p>
        <p className='notFound_text'>the page you're looking for may have been removed, renamed, or temporarily unavailable.</p>
        <Link to="/" className='notFound_button'>Return to the Homepage</Link>
      </section>
    </main>
  );
}

export default NotFound;
